import React from 'react';
import styled from 'styled-components';
import { productSelector, setHighlightedProductAdder, resetSteps } from '@src/stores/product';
import {
  useAppSelector,
  useAppDispatch,
  useWidgetParam,
  useWidgetLocalParams,
  useWidgetsTheme,
  useTranslate,
} from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { GradientButton } from '@src/components/reusable';
import { track } from '@src/services/analytics';

const ProductAdderButton = () => {
  const id = useWidgetId();
  const productId = useWidgetParam('product-id')!;
  const dispatch = useAppDispatch();
  const product = useAppSelector(productSelector(productId));
  const productCtaText = useWidgetParam('product-cta-text');
  const actionColor = useWidgetsTheme('actionColor');
  const { i18n } = useTranslate();
  const localParams = useWidgetLocalParams();

  const handleButtonClick = () => {
    track('productPageBuyClick', {
      productId: productId,
      productName: product?.name,
    });
    dispatch(resetSteps(id));
    dispatch(setHighlightedProductAdder(id, localParams));
  };

  const getCtaText = () => (productCtaText ? productCtaText : i18n('adder_purchaseButton'));

  return (
    <>
      <ButtonContainer>
        <GradientButton actionColor={actionColor} onClick={handleButtonClick} disabled={!product}>
          {product ? getCtaText() : i18n('base_loading')}
        </GradientButton>
      </ButtonContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  max-width: 300px;
`;

export default ProductAdderButton;
